import React, { useState, useEffect } from 'react';
import { message } from 'antd';
import { useHeaderChanger } from 'hooks/useHeaderChanger';
import { PageFormBox } from 'ui/PageFormBox';
import { IntegrationService } from 'services/IntegrationService';
import { SMS_INTEGRATION } from 'constants/integration';
import { useDocumentTitle } from 'hooks/useDocumentTitle';
import { FETCHING_STATUS, REQUEST_LOADING } from 'constants/alerts';
import { IntegrationForm } from '../IntegrationForm';

function SMS() {
  useDocumentTitle('Настройки интеграции с SMS Шлюзом');
  useHeaderChanger('Настройки интеграции с SMS Шлюзом');
  const [config, setConfig] = useState(null);

  useEffect(() => {
    fetchSMSConfig();
  }, []);

  const fetchSMSConfig = async () => {
    const hide = message.loading(FETCHING_STATUS);

    try {
      const { items } = await IntegrationService.getConfig(SMS_INTEGRATION);
      setConfig({
        login: items?.global_smsc?.login,
        password: items?.global_smsc?.pwd,
        integration: items?.smsc_conf?.smsc_enable,
        url: items?.smsc_conf?.smsc_send_url,
      });
    } catch (err) {
      message.error('Не удалось загрузить конфиг');
    } finally {
      hide();
    }
  };

  const handleSubmit = async ({ login, password, url, integration }) => {
    const hide = message.loading(REQUEST_LOADING);
    const payload = {
      global_smsc: {
        login,
        pwd: password,
      },
      smsc_conf: {
        smsc_enable: integration,
        smsc_send_url: url,
      },
    };

    try {
      const isSuccess = await IntegrationService.saveConfig(
        SMS_INTEGRATION,
        payload
      );

      if (isSuccess) {
        message.success('Успешно сохранено');
      }
    } catch (err) {
      message.error('Не удалось сохранить данные');
    } finally {
      hide();
    }
  };

  return (
    <PageFormBox>
      <IntegrationForm
        pageId="IntegrationConfig"
        config={config}
        formTitle="Глобальные настройки для интеграции с smsc"
        onSubmit={handleSubmit}
      />
    </PageFormBox>
  );
}

export { SMS };
